import i18next from 'i18next'
import i18nextBrowserLanguagedetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import translations from './assets/dictionaries/translation'
import { initReactI18next } from 'react-i18next'

const localeNamespace = 'translations'
const SUPPORTED_LOCALES = ['en', 'fi'] as const
const FALLBACK_LOCALE = 'en' as const
const storedLocale = localStorage.getItem('i18nextLng')
const defaultLocale: string =
  storedLocale && (SUPPORTED_LOCALES as readonly string[]).includes(storedLocale) ? storedLocale : FALLBACK_LOCALE

i18next
  .use(Backend)
  .use(i18nextBrowserLanguagedetector)
  .use(initReactI18next)
  .init({
    lng: defaultLocale,
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    load: 'languageOnly',
    debug: false,
    // have a common namespace used around the full app
    ns: [localeNamespace],
    defaultNS: localeNamespace,
    returnObjects: true,
    keySeparator: false, // we use content as keys
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: false,
    },
    // we init with resources
    resources: translations,
  })

export default i18next
